import { ApolloError, isApolloError } from "@apollo/client";
import { ResultCodes } from "@app/service/resultCodes";

export const isExternalServerError = (error?: ApolloError) =>
  error &&
  isApolloError(error) &&
  error?.graphQLErrors[0]?.extensions?.code ===
    ResultCodes.EXTERNAL_SERVER_ERROR;
